import Vue from 'vue';
import UserService from '@/service/user.service';
import HelperPlugin from '@/plugins/helper.plugin';
import UiEventBus from '@/UiEventBus';
import categoryApi from '@/api/category';

Vue.use(HelperPlugin);
export default new Vue({
  name: 'CategoryService',
  data() {
    return {
      categories: [],
      language: 'en',
    };
  },
  computed: {
    tree() {
      const tree = this.getTree(this.categories);
      return tree;
    },
    richCategories() {
      return this._getCategoriesRecursively(this.categories.filter(c => !c.parentCategory))
        .filter(c => c.level <= 2)
        .flatMap(c => [c, ...c.children]);
    },
    richAllCategories() {
      return this._getCategoriesRecursively(this.categories.filter(c => !c.parentCategory))
        .filter(c => c.level <= 2)
        .flatMap(c => [c, ...this._getCategoriesRecursively(c.children, 1)]);
    },
  },
  methods: {
    getTree(categories, parentCategoryId = null, tree = {}) {
      categories
        .filter(c => c.parentCategoryId === parentCategoryId)
        .forEach(c => {
          tree[c.engineName] = { ...c, children: this.getTree(categories, c.id) };
        });
      return tree;
    },
    async getCategories() {
      this.categories = await categoryApi.getCategories();
    },
    getMainParentCategory(category) {
      let parentCategory = category;
      if (!parentCategory) return null;
      while (parentCategory?.parentCategoryId) {
        parentCategory = this.categories.find(c => c.id === parentCategory.parentCategoryId);
      }
      return parentCategory;
    },
    getCategoryById(id) {
      return this.categories.find(c => c.id === id);
    },
    getCategoryTreeString(category, removeMain = false) {
      if (!category) return '';
      let parents = [];
      parents.push(category.nameText);
      if (category.parentCategory) {
        while (category.parentCategory) {
          parents.push(category.parentCategory.nameText);
          category = category.parentCategory;
        }
      }
      if (removeMain) parents.pop();
      return parents.reverse().join(' > ');
    },
    init() {
      const userInfo = UserService.getUserInfo();
      if (this.language !== userInfo?.language) {
        this.language = userInfo?.language;

        if (userInfo) {
          this.getCategories();
        }
      } else if (this.categories.length === 0 && userInfo) {
        this.getCategories();
      }
      if (userInfo) this.getCategories();
    },
    _getCategoriesRecursively(categories, level = 0) {
      return categories.map(c => {
        c.level = level;
        c.children = this._getCategoriesRecursively(
          this.categories.filter(cc => cc.parentCategory?.id === c.id),
          level + 1
        );
        return c;
      });
    },
  },
  created() {
    UiEventBus.$on('userInfoChanged', this.init);
  },
  beforeDestroy() {
    UiEventBus.$off('userInfoChanged', this.init);
  },
});
